import styled from "styled-components";
// conforming to new standard, new styles to use styled components

export const ChildrenList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #1a1a1a;
  padding: 1em;
  border-radius: 2px;
//   padding: 1em 2em;
  text-transform: uppercase;
//   height: 320px;
  width: 100%;
  color: #fff;
  margin-bottom: 2em;

  & > * {
    width: 100%;
  }
  div.children-list {
    margin-top: -2.5em;
  }
  h2.label,
  h3.label {
    font: italic bold 24px "Roboto Condensed";
    color: #fff;
    margin-top: -1.25em;
    width: 100%;
  }

  p.no-child {
    font: italic bold 20px "Roboto Condensed";
    text-align: center;
    color: #ff0033;
  }

  div.child-entry {
    width: 90%;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 1em;
    transform: scale(1);
    transition: transform 0.5s ease-in-out;
    cursor: pointer;

    &:hover {
      transform: scale(1.05);
      transition: transform 0.5s ease-in-out;
    }

    p.child-name {
      text-align: left;
      font: bold italic 18px "Roboto Condensed";
      margin-bottom: 0 !important;
      color: #000;
    }
  }

  button.new-child {
    background-color: transparent;
    border: 1px solid #acff24;
    width: 90%;
    height: 45px;
    color: #fff !important;
  }
`;

export const ParentResource = styled.div`
  width: 100%;
height: 80%;
  diplay: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 2px;
  text-align: center;
  color: #fff;
  padding: .25em 1em;

  p.blog-title {
    font: italic normal 16px "Roboto Condensed";
    color: #acff24;
  }
  p {
    font: normal normal 16px "Roboto Condensed";
  }
  img {
    height: auto;
    width: auto;
    margin-bottom: 8px;
  }
  div.inner-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 0;
    height: 100%;
  }
  button {
    height: 30px;
    padding: 0 1em;
  }
`;

export const ResourceWrapper = styled.div`
  width: ${(props) => (props.width ? props.width : "260px")};
  height: 260px;
  min-width: 222px;
  background-color: #1a1a1a;
//   margin: 0 1em;
  h2.resource-header {
    font: italic bold 20px "Roboto Condensed";
    color: #fff;
    margin-top: -0.5em;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Assessments/ParentAssessementResult.styles.ts